'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.UserManagement.Common', 'AVRO.UserManagement.AssignRole'];
module.exports = angular.module('AVRO.UserManagement.DefaultRoleView', dependencies).directive('rmDefaultRoleView', require('./directives/DefaultRoleViewDirective')).controller('DefaultRoleViewController', require('./controllers/DefaultRoleViewController'));